import React from "react";


function Plus7Header() {

    return (
        <>
            <div className="pd-header">

                <div className="header-bottom">
                    <h2 className="pd-title has-bg-image">CAMP +7</h2>
                </div>
            </div>
        </>
    );
}

export default Plus7Header;
